export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
